import WebGLCoordinate from '../../WebGLCoordinate';
import PrimitiveShape from '../PrimitiveShape';

export default class WebGLLineStrip extends PrimitiveShape {

	public constructor (private coordinates: WebGLCoordinate[]) {
		super(WebGL2RenderingContext.LINE_STRIP, WebGLLineStrip.getVertexArray(coordinates));
	}

	public static fromNumbers (numbers: number[]) {
		const coordinates: WebGLCoordinate[] = [];

		for (let i = 0; i < numbers.length; i += 2) {
			coordinates.push(new WebGLCoordinate(numbers[i], numbers[i + 1]));
		}

		return new WebGLLineStrip(coordinates.reverse());
	}

	public static circle (cx: number, cy: number, radius: number, sectors: number, startAngle = 0, endAngle = Math.PI * 2) {
		const coordinates: WebGLCoordinate[] = [];

		for (let i = 0; i <= sectors; i++) {
			const angle = startAngle + (endAngle - startAngle) * i / sectors;
			coordinates.push(new WebGLCoordinate(cx + radius * Math.cos(angle), cy + radius * Math.sin(angle)));
		}

		return new WebGLLineStrip(coordinates);
	}

	public static fromFunction (func: (x: number) => number, minX: number, maxX: number, steps: number, xScale: number, yScale: number) {
		const coordinates: WebGLCoordinate[] = [];

		const diffX = maxX - minX;
		for (let i = 0; i <= steps; i++) {
			const x = minX + diffX * i / steps;
			const y = func(x);

			coordinates.push(new WebGLCoordinate(x / xScale, y / yScale));
		}

		return new WebGLLineStrip(coordinates);
	}

	public copy () {
		return new WebGLLineStrip(this.coordinates).setColor(this.getColor());
	}

	/*
	 * Private methods
	 */

	private static getVertexArray (coordinates: WebGLCoordinate[]) {
		const vertexArray: number[] = [];

		coordinates.forEach(coordinate => {
			vertexArray.push(coordinate.getX());
			vertexArray.push(coordinate.getY());
			vertexArray.push(0);
			vertexArray.push(1);
		});

		return vertexArray;
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/webGL/shapes/primitives/WebGLLineStrip.ts